import Component_Interface from '@/nextts/edit/Component_Interface'
import Component_Model from  '@/nextts/model/Component_Model';
import gsap from "gsap";
import Animation_Model from '../model/Animation_Model';
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid';

//기본 데이터 속성
class EditBasic_Element extends HTMLElement implements Component_Interface{
    
    //Component_Interface 구현
    prevtype:number | undefined;   //이전 컴포넌트 타입. 타입이 바뀌면 한번 지워주고 그려라.
    model:Component_Model;
    timeline?:null|GSAPTimeline;

    //SVG 텍스트 전용
    svgElement?: null|SVGSVGElement;
    textPathElement?: null|SVGTextPathElement;
    path?:null|SVGPathElement;
    text?:null|SVGTextElement;
    defs?:null|SVGDefsElement;

    //SVG 상태 추적용
    lastSVGPath?: string;
    lastSVGColor?: string;
    lastSVGColorUse?: boolean;

    //이미지 마스크용
    base64String?:null|string;
    
    //셀렉트락 처리
    selectlock:boolean = false;

    constructor(cm:Component_Model){
        super();
        this.model = cm;
        if(this.model != null){
            this.prevtype = this.model.component_type;
        }
        

        //좌표체계
        this.style.position = "absolute";

        //movealbe 및 selecto 타겟팅
        // Shape 컴포넌트는 일시적으로 다른 클래스 사용 (드래그 문제 해결)
        this.classList.add("drag");
        

        //그룹 복원
        if(this.model != null && this.model != undefined){
            if(this.model.isgroup != null && this.model.isgroup && this.model.groupid.length > 0){
                this.classList.add(this.model.groupid);
            }
        }
        
        //이벤트 추가
        this.ondblclick  = this.event_doubleclick;
        this.onkeydown   = this.onkeydownevent;
        this.onkeyup     = this.onkeyupevent;
        
        this.onmousedown = this.onmousedown_event;
        this.onmouseup   = this.onmouseup_event;
        this.onmouseover = this.onmouseover_event;
        this.onmouseout = this.onmouseout_event;

        this.updateRender();
        this.updateTransElementAll();
        
    }


    async checkLock(){
        if(this.model.selectlock){
            this.selectlock = true;
            this.contentEditable = "false";
            this.classList.remove("select-locked");
        }else{
            this.selectlock = false;
            this.classList.add("select-locked");
        }

        if(this.model.movelock){
            this.classList.remove("drag");
        }else{
            this.classList.add("drag");
        }
    }


    //Component_Interface 구현 - 컴포넌트 외형 그리기
    async updateRender(){

        //console.log("bg : " + this.model.backgroundColor);

        if(this.model == null || this.model == undefined){
            return;
        }

        // showlock이 true면 컴포넌트를 숨김
        if(this.model.showlock){
            this.style.visibility = "hidden";
            this.style.pointerEvents = "none";
            return;
        } else {
            this.style.visibility = "visible";
            this.style.pointerEvents = "auto";
        }

        if(this.prevtype != this.model.component_type){
            //타입이 변경되면 한번 초기화 필요.
            while (this.firstChild) {
                this.removeChild(this.firstChild);
            }                
            this.svgElement = null;
            this.textPathElement = null;
            this.path = null;
            this.text = null;
            this.defs = null;
            this.prevtype = this.model.component_type;
        }

        //컴포넌트의 배경타입은 사용하지 않기로 함. 무조건 투명으로 나오게 해라.
        this.style.backgroundColor  = "#00000000";
        this.style.backgroundImage  = "";
        this.style.whiteSpace       = "normal";
        this.style.overflow         = "visible";
        this.style.textShadow       = "";
        this.style.boxShadow        = "";
        this.style.opacity          = String(this.model.opacity);
        this.style.border           = "";

        /*
        if(this.model.bgtype == 0){
            //color
            this.style.backgroundColor  = this.model.backgroundColor;
            this.style.backgroundImage  = "";
            this.style.backgroundRepeat = "no-repeat";
        }else if(this.model.bgtype == 1){
            //image
            this.style.backgroundColor  = "#00000000";
            this.style.backgroundSize   = this.model.width + "px " + this.model.height + "px";
            this.style.backgroundImage  = "url('"+this.model.backgroundImg+"')"
            this.style.backgroundRepeat = "no-repeat";
        }
        */


        //컴포넌트 타입
        if(this.model.component_type == Component_Model.COMPONENT_TEXT || this.model.component_type == Component_Model.COMPONENT_DATETIME){

            this.innerText          = this.model.text;
            this.style.fontFamily   = this.model.textfont;
            this.style.fontSize     = this.model.textsize+'px';
            this.style.textAlign    = this.model.texthori_align;    //left, center, right
            
            //텍스트 세로 정렬
            this.style.display          = "flex";
            this.style.flexDirection    = "column";
            this.style.lineHeight       = "120%";
            this.style.justifyContent   = this.model.textverti_align;       //top, center, end
            
            this.style.letterSpacing    = this.model.letterSpacing+"px" 
            this.style.lineHeight       = this.model.lineHeight+"%"     
            
            //언더라인
            if(this.model.textUnderline == 0){
                this.style.textDecoration = "none";
            }else{
                this.style.textDecoration = "underline";
            }
            
            //볼드
            if(this.model.textBold == 0){
                this.style.fontWeight = this.model.font_weight == null || this.model.font_weight.length == 0 ? "normal" : this.model.font_weight;
            }else{
                this.style.fontWeight = this.model.font_weight == null || this.model.font_weight.length == 0 ? "bold" : this.model.font_weight;
            }

            //이탤릭
            if(this.model.textItalic == 0){
                this.style.fontStyle = "normal";
            }else{
                this.style.fontStyle = "italic";
            }


            //input 텍스트처리 (더블클릭시)
            this.contentEditable = "true";

            //그림자 우측, 아래, 블러범위, 색상
            if(this.model.shadow_use){
                this.style.textShadow = `${this.model.shadow_hori}px ${this.model.shadow_verti}px ${this.model.shadow_blur}px ${this.model.shadow_color}`;    
                //this.style.textShadow = "-4px -4px 0 #000,4px -4px 0 #000,-4px 4px 0 #000,4px 4px 0 #000,-8px 0 0 #FF0000,8px 0 0 #FF0000,0 -8px 0 #FF0000,0 8px 0 #FF0000";
            }else{
                this.style.textShadow = "";
            }

            //외각선 처리
            if(this.model.outline_use){
                this.style.webkitTextStroke = `${this.model.outline_size}px ${this.model.outline_color}`;  
            }else{
                this.style.webkitTextStroke = "";
            }

            this.style.backgroundClip  = "";
            this.style.webkitBackgroundClip = "";
            this.style.backgroundImage = "";
            this.style.color = this.model.textcolor;
            this.style.webkitTextFillColor = this.model.textcolor;

            //세로배치시 영문과 특수문자가 옆으로 누워버림.
            //this.style.writingMode = this.model.writingMode;

            if(this.model.component_type == Component_Model.COMPONENT_DATETIME){
                this.contentEditable = "false"; //텍스트 변경 불가
                if(this.model.date_type.length > 0){
                    this.innerText = moment(new Date().toString()).format(this.model.date_type);
                }
            }

        }else if(this.model.component_type == Component_Model.COMPONENT_ARTTEXT){            

            //input 텍스트처리 (더블클릭시)
            this.contentEditable = "true";

            /***************************************************************************
             SVG TEXT를 사용 (연구중, 현재 사용안함.)
             문제1. 리니어 그라데이션이 엉뚱한 좌표로 회전함.
             문제2. 여러개의 SVG TEXT사용시 렌더링이 꼬임.
             문제4. 그림자도 defs로 따로 만들어야함.
            ***************************************************************************/
            if(this.svgElement == null){
                this.svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                this.defs = document.createElementNS(this.svgElement.namespaceURI, "defs") as SVGDefsElement;
                this.path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                this.text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                this.textPathElement = document.createElementNS('http://www.w3.org/2000/svg', 'textPath');
                this.svgElement.appendChild(this.defs);
                this.svgElement.appendChild(this.path);
                this.svgElement.appendChild(this.text);
                this.text.appendChild(this.textPathElement);
                this.appendChild(this.svgElement);      
            }
           this.svgElement.setAttribute("width", `${this.model.width}`);
           this.svgElement.setAttribute("height", `${this.model.height}`);

            //휘어짐.
            //m이 소문자여야 상대좌표다. 대문자면 절대좌표임. 시작x,y 커브기준점 x,y, 종료x,종료높이 0이면 처음높이 그대로.
            this.path!.setAttribute('d', `m 0 ${(this.model.height/2)+(this.model.textsize/2)+this.model.text_offsetverti} q ${this.model.width/2}, ${this.model.text_arc} ${this.model.width}, 0`)
            this.path!.setAttribute('fill', 'none');
            this.path!.setAttribute('stroke', 'red');
            const textuuid = uuidv4();
            this.path!.setAttribute('id', `${textuuid}`);

            this.text!.style.fontFamily = this.model.textfont;
            this.text!.style.fontSize = `${this.model.textsize}px`;
            this.text!.style.textAlign    = this.model.texthori_align;    //left, center, right

            //텍스트 세로 정렬
            //this.text!.style.display          = "flex";
            //this.text!.style.flexDirection    = "column";
            //this.text!.style.lineHeight       = "120%";
            //this.text!.style.justifyContent   = this.model.textverti_align;       //top, center, end

            this.text!.style.letterSpacing    = this.model.letterSpacing+"px" 
            this.text!.style.lineHeight       = this.model.lineHeight+"%"     

            if(this.model.color_type == "color"){
                this.text!.style.fill       = this.model.textcolor;

            }else if(this.model.color_type == "gradient"){

                //하위 효과 초기화
                while (this.defs && this.defs.firstChild) {
                    this.defs.removeChild(this.defs.firstChild);
                }                
                
                // SVGLinearGradientElement 타입으로 linearGradient 요소 생성
                if(this.model.gradient.type == "linear"){

                    //linear
                    const linearGradient: SVGLinearGradientElement = document.createElementNS(this.svgElement.namespaceURI, "linearGradient") as SVGLinearGradientElement;
                    const gradient_id = uuidv4();
                    linearGradient.setAttribute("id", `${gradient_id}`);
                    linearGradient.setAttribute("gradientTransform", `rotate(${Number(this.model.gradient.degree)-90})`);
                    linearGradient.setAttribute("gradientUnits", "userSpaceOnUse");
                    // SVGStopElement 타입으로 첫 번째 stop 요소 생성
                    for(const point of this.model.gradient.points){
                        const stop: SVGStopElement = document.createElementNS(this.svgElement.namespaceURI, "stop") as SVGStopElement;
                        stop.setAttribute("offset", `${point.left}%`);
                        stop.setAttribute("style", `stop-color:rgba(${point.red},${point.green},${point.blue},${point.alpha})`);
                        linearGradient.appendChild(stop);
                    }
    
                    // 요소들을 조립
                    this.defs!.appendChild(linearGradient);
                    this.text!.style.fill       = `url(#${gradient_id})`;
                    

                }else{
                    //radial
                    const radialGradient: SVGRadialGradientElement = document.createElementNS(this.svgElement.namespaceURI, "radialGradient") as SVGRadialGradientElement;
                    const gradient_id = uuidv4();
                    radialGradient.setAttribute("id", `${gradient_id}`);
                    radialGradient.setAttribute("cx", "50%");
                    radialGradient.setAttribute("cy", "50%");
                    radialGradient.setAttribute("r", "10%");
                    // SVGStopElement 타입으로 첫 번째 stop 요소 생성
                    for(const point of this.model.gradient.points){
                        const stop: SVGStopElement = document.createElementNS(this.svgElement.namespaceURI, "stop") as SVGStopElement;
                        stop.setAttribute("offset", `${point.left}%`);
                        stop.setAttribute("style", `stop-color:rgba(${point.red},${point.green},${point.blue},${point.alpha})`);
                        radialGradient.appendChild(stop);
                    }
                    // 요소들을 조립
                    this.defs!.appendChild(radialGradient);
                    this.text!.style.fill       = `url(#${gradient_id})`;
                }
                
            }else if(this.model.color_type == "image"){
                //console.log("image...");
            }
            
            

            //외각선
            if(this.model.outline_use){ 
                this.text!.style.stroke = `${this.model.outline_color}`;
                this.text!.style.strokeWidth = `${this.model.outline_size}`;
                this.text!.style.strokeDasharray = `${this.model.outline_dash1},${this.model.outline_dash2}`;
                this.text!.style.strokeDashoffset = `${this.model.outline_offset}`;
            }else{
                this.text!.style.stroke = "";
                this.text!.style.strokeWidth = "";
            }             


            //언더라인
            if(this.model.textUnderline == 0){
                this.text!.style.textDecoration = "none";
            }else{
                this.text!.style.textDecoration = "underline";
            }
            
            //볼드
            if(this.model.textBold == 0){
                this.text!.style.fontWeight = this.model.font_weight == null || this.model.font_weight.length == 0 ? "normal" : this.model.font_weight;
            }else{
                this.text!.style.fontWeight = this.model.font_weight == null || this.model.font_weight.length == 0 ? "bold" : this.model.font_weight;
            }

            //이탤릭
            if(this.model.textItalic == 0){
                this.text!.style.fontStyle = "normal";
            }else{
                this.text!.style.fontStyle = "italic";
            }


            //input 텍스트처리 (더블클릭시)
            //this.contentEditable = "true";

            //그림자 우측, 아래, 블러범위, 색상
            if(this.model.shadow_use){
                //this.style.textShadow = `${this.model.shadow_hori}px ${this.model.shadow_verti}px ${this.model.shadow_blur}px ${this.model.shadow_color}`;    
            }else{
                //this.style.textShadow = "";
            }

            //anchor가 중앙이면 x좌표를 중앙으로 맞춤.
            
            if(this.model.texthori_align == "left"){
                this.text!.setAttribute("x","0%");
                this.text!.setAttribute("text-anchor","start");
            }else if(this.model.texthori_align == "center"){
                this.text!.setAttribute("x","50%");
                this.text!.setAttribute("text-anchor","middle");
            }else if(this.model.texthori_align == "right"){
                this.text!.setAttribute("x","100%");
                this.text!.setAttribute("text-anchor","end");
            }
            
            if(this.model.textverti_align == "top"){
                this.text!.setAttribute("y","0%");
            }else if(this.model.texthori_align == "center"){
                this.text!.setAttribute("y","50%");
            }else if(this.model.texthori_align == "end"){
                this.text!.setAttribute("y","100%");
            }
            

            //anchor가 중앙이면 x좌표를 중앙으로 맞춤.
            /*
            this.text!.setAttribute("x","50%");
            this.text!.setAttribute("text-anchor","middle");
            */
           
            this.textPathElement!.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', `#${textuuid}`);
            this.textPathElement!.setAttribute('startOffset', `${this.model.text_offset}`);
            this.textPathElement!.textContent = this.model.text;

        }else if(this.model.component_type == Component_Model.COMPONENT_IMAGE){
            //console.log("update render : component type image : " + this.model.image);

            this.style.backgroundSize   = this.model.width + "px " + this.model.height + "px";
            this.style.backgroundRepeat = "no-repeat";

            if(this.model.api_use){
                const imgPath = require('@/assets/apilogo.png');
                this.style.backgroundImage  = `url(${imgPath})`
                this.style.backgroundSize   = "50%";
                this.style.backgroundPosition = "center";
                this.style.backgroundColor = "white";
            }else{
                if(this.model.image != null && this.model.image != undefined && this.model.image.length > 0){
                    if(this.model.image.toLowerCase().startsWith("http")){
                        //인터넷에 업로드된 이미지면
                        this.style.backgroundImage  = "url('"+this.model.image+"')"
                        this.innerHTML = "";
                    }else{
                        this.style.backgroundImage  = `url(${this.model.image})`;
                        this.innerHTML = "";
                    }
                }else{
                    //아무것도 없으면
                    this.style.backgroundImage = "";
                    this.innerHTML = `<div style="display: flex; align-items: center; justify-content: center; height: 100%; color: #999; font-size: 14px; border: 2px dashed #ddd; border-radius: 4px;">
                        <div style="text-align: center;">
                            <div style="font-size: 24px; margin-bottom: 8px;">🖼️</div>
                            <div>이미지</div>
                        </div>
                    </div>`;
                }
            }
            
            this.style.backgroundRepeat = "no-repeat";

            //input 텍스트처리 (더블클릭시)
            this.contentEditable = "false";

            //border-radius 처리
            const hasSeparateRadius = this.model.border_radius_tl > 0 || 
                                    this.model.border_radius_tr > 0 || 
                                    this.model.border_radius_bl > 0 || 
                                    this.model.border_radius_br > 0;
            
            if (hasSeparateRadius) {
                this.style.borderRadius = `${this.model.border_radius_tl}px ${this.model.border_radius_tr}px ${this.model.border_radius_br}px ${this.model.border_radius_bl}px`;
            } else {
                this.style.borderRadius = `${this.model.border_radius}px`;
            }

            //그림자 처리 (이미지용 filter)
            if(this.model.shadow_use){
                this.style.filter = `drop-shadow(${this.model.shadow_hori}px ${this.model.shadow_verti}px ${this.model.shadow_blur}px ${this.model.shadow_color})`;    
            }else{
                this.style.filter = "";
            }


            //마스크 처리
            if(this.model.mask_use){
                this.style.webkitMaskPosition   = `${this.model.mask_left}% ${this.model.mask_top}%`;
                this.style.webkitMaskSize       = `${this.model.mask_width}% ${this.model.mask_height}%`;
                if(this.model.mask_repeat){
                    this.style.webkitMaskRepeat = "repeat";    
                }else{
                    this.style.webkitMaskRepeat = "no-repeat";    
                }
                if(this.model.mask_image.length > 0){
                    
                    if(this.model.mask_image.toLowerCase().startsWith("http")){
                        //인터넷에 업로드된 이미지면
                        try {
                            if(this.base64String == null){
                                this.base64String = await this.convertImageToBase64(this.model.mask_image);
                            }
                            this.style.webkitMaskImage = `url(${this.base64String})`;    
                        } catch (error) {
                            console.error("Error during image conversion to Base64:", error);
                        }                        
                    }else{
                        this.style.webkitMaskImage = `url(${this.model.mask_image})`;
                    }

                }else{
                    this.style.webkitMaskImage = ""; 
                }
                
            }else{
                this.style.webkitMaskImage = "";
                this.style.webkitMaskPosition = "";
                this.style.webkitMaskSize = "";
            }

        }else if(this.model.component_type == Component_Model.COMPONENT_TEXTSWITCHER){

            
            if(this.model.api_use){
                this.innerText          = "API 텍스트 스위처";
            }else{
                if(this.model.textswitcher_list != null && this.model.textswitcher_list.length > 0){
                    this.innerText          = this.model.textswitcher_list[0] as string;
                }else{
                    this.innerText          = "입력된 텍스트가 없습니다.";
                }
            }
    
            this.style.fontFamily   = this.model.textfont;
            this.style.fontSize     = this.model.textsize+'px';
            this.style.color        = this.model.textcolor;
            this.style.textAlign    = this.model.texthori_align;    //left, center, right

            //텍스트 세로 정렬
            this.style.display          = "flex";
            this.style.flexDirection    = "column";
            this.style.lineHeight       = "120%";
            this.style.justifyContent   = this.model.textverti_align;       //top, center, end
            
            this.style.letterSpacing    = this.model.letterSpacing+"px" 
            this.style.lineHeight       = this.model.lineHeight+"%"     
            
            //언더라인
            if(this.model.textUnderline == 0){
                this.style.textDecoration = "none";
            }else{
                this.style.textDecoration = "underline";
            }
            
            //볼드
            if(this.model.textBold == 0){
                this.style.fontWeight = this.model.font_weight == null || this.model.font_weight.length == 0 ? "normal" : this.model.font_weight;
            }else{
                this.style.fontWeight = this.model.font_weight == null || this.model.font_weight.length == 0 ? "bold" : this.model.font_weight;
            }

            //이탤릭
            if(this.model.textItalic == 0){
                this.style.fontStyle = "normal";
            }else{
                this.style.fontStyle = "italic";
            }

            //그림자 우측, 아래, 블러범위, 색상
            if(this.model.shadow_use){
                this.style.textShadow = `${this.model.shadow_hori}px ${this.model.shadow_verti}px ${this.model.shadow_blur}px ${this.model.shadow_color}`;    
            }
            
            if(this.model.outline_use){
                this.style.webkitTextStroke = `${this.model.outline_size}px ${this.model.outline_color}`;  
            }

            //input 텍스트처리 (더블클릭시)
            this.contentEditable = "false";

        }else if(this.model.component_type == Component_Model.COMPONENT_IMAGESWITCHER){

            if(this.model.api_use){
                this.style.backgroundColor  = "#00000000";
                this.style.backgroundImage  = "";
                this.style.backgroundRepeat = "no-repeat";
    
                this.style.color            = "black";
                this.innerText              = "API 이미지 스위처";
                this.style.textAlign        = "center";    
                this.style.display          = "flex";
                this.style.flexDirection    = "column";
                this.style.lineHeight       = "120%";
                this.style.justifyContent   = "center";
            }else{
                if(this.model.imgswitcher_list != null && this.model.imgswitcher_list.length > 0){
                    this.style.backgroundSize   = this.model.width + "px " + this.model.height + "px";
                    this.style.backgroundRepeat = "no-repeat";
                    if(this.model.imgswitcher_list[0].toLowerCase().startsWith("http")){
                        //인터넷에 업로드된 이미지면
                        this.style.backgroundImage  = "url('"+this.model.imgswitcher_list[0]+"')"
                    }else{
                        this.style.backgroundImage  = `url(${this.model.imgswitcher_list[0]})`;
                    }
                    this.innerText              = "";
                }else{
                    this.style.backgroundImage  = "";
                    this.style.backgroundRepeat = "no-repeat";
                    this.innerHTML = `<div style="display: flex; align-items: center; justify-content: center; height: 100%; color: #999; font-size: 14px; border: 2px dashed #ddd; border-radius: 4px;">
                        <div style="text-align: center;">
                            <div style="font-size: 24px; margin-bottom: 8px;">🔄</div>
                            <div>이미지 스위처</div>
                        </div>
                    </div>`;
                }
            }
            
            //input 텍스트처리 (더블클릭시)
            this.contentEditable = "false";

            //border-radius 처리
            const hasSeparateRadius = this.model.border_radius_tl > 0 || 
                                    this.model.border_radius_tr > 0 || 
                                    this.model.border_radius_bl > 0 || 
                                    this.model.border_radius_br > 0;
            
            if (hasSeparateRadius) {
                this.style.borderRadius = `${this.model.border_radius_tl}px ${this.model.border_radius_tr}px ${this.model.border_radius_br}px ${this.model.border_radius_bl}px`;
            } else {
                this.style.borderRadius = `${this.model.border_radius}px`;
            }

            //마스크 처리
            if(this.model.mask_use){
                this.style.webkitMaskPosition   = `${this.model.mask_left}% ${this.model.mask_top}%`;
                this.style.webkitMaskSize       = `${this.model.mask_width}% ${this.model.mask_height}%`;
                if(this.model.mask_repeat){
                    this.style.webkitMaskRepeat = "repeat";    
                }else{
                    this.style.webkitMaskRepeat = "no-repeat";    
                }
                if(this.model.mask_image.length > 0){
                    //https://cdn.icon-icons.com/icons2/692/PNG/512/seo-social-web-network-internet_132_icon-icons.com_61506.png
                    this.style.webkitMaskImage = `url(${this.model.mask_image})`;
                }else{
                    this.style.webkitMaskImage = "";    
                }
            }else{
                this.style.webkitMaskImage = "";
                this.style.webkitMaskPosition = "";
                this.style.webkitMaskSize = "";
            }


        }else if(this.model.component_type == Component_Model.COMPONENT_COLOR){

            if(this.model.color_type == "color"){
                this.style.backgroundColor  = this.model.backgroundColor;
                //this.style.background       = "";
            }else if(this.model.color_type == "gradient"){
                //this.style.backgroundColor  = "";
                this.style.background       = this.model.backgroundColor;
            }
            
            //this.style.backgroundImage  = ""; //그라디언트 때문에..

            //border-radius 처리
            const hasSeparateRadius = this.model.border_radius_tl > 0 || 
                                    this.model.border_radius_tr > 0 || 
                                    this.model.border_radius_bl > 0 || 
                                    this.model.border_radius_br > 0;
            
            if (hasSeparateRadius) {
                this.style.borderRadius = `${this.model.border_radius_tl}px ${this.model.border_radius_tr}px ${this.model.border_radius_br}px ${this.model.border_radius_bl}px`;
            } else {
                this.style.borderRadius = `${this.model.border_radius}px`;
            }

            //외각선
            if(this.model.outline_use){ 
                this.style.border = `${this.model.outline_size}px solid ${this.model.outline_color}`;
            }else{
                this.style.border = "";
            }             

            this.style.backgroundRepeat = "no-repeat";
            this.innerText = "";
            this.contentEditable = "false";

            //그림자 우측, 아래, 블러범위, 색상
            if(this.model.shadow_use){
                this.style.boxShadow = `${this.model.shadow_hori}px ${this.model.shadow_verti}px ${this.model.shadow_blur}px ${this.model.shadow_color}`;    
            }

            //마스크 처리
            
            if(this.model.mask_use){
                this.style.webkitMaskPosition   = `${this.model.mask_left}% ${this.model.mask_top}%`;
                this.style.webkitMaskSize       = `${this.model.mask_width}% ${this.model.mask_height}%`;
                if(this.model.mask_repeat){
                    this.style.webkitMaskRepeat = "repeat";    
                }else{
                    this.style.webkitMaskRepeat = "no-repeat";    
                }
                if(this.model.mask_image.length > 0){
                    //https://cdn.icon-icons.com/icons2/692/PNG/512/seo-social-web-network-internet_132_icon-icons.com_61506.png
                    this.style.webkitMaskImage = `url(${this.model.mask_image})`;
                }else{
                    this.style.webkitMaskImage = "";    
                }
            }else{
                this.style.webkitMaskImage = "";
                this.style.webkitMaskPosition = "";
                this.style.webkitMaskSize = "";
            }
            


        }else if(this.model.component_type == Component_Model.COMPONENT_MOVIE){

            this.style.backgroundColor  = "black";
            
            if(this.model.image != null && this.model.image != undefined && this.model.image.length > 0){
                //썸네일을 컴포넌트 영역에 꽉차게 (이미지 컴포넌트와 동일 방식)
                this.style.backgroundSize   = this.model.width + "px " + this.model.height + "px";
                this.style.backgroundPosition = "left top";
                if(this.model.image.toLowerCase().startsWith("http")){
                    //인터넷에 업로드된 이미지면
                    this.style.backgroundImage  = "url('"+this.model.image+"')"
                    this.innerHTML = "";
                }else{
                    this.style.backgroundImage  = `url(${this.model.image})`;
                    this.innerHTML = "";
                }
            }else{
                const imgPath = require('@/assets/playlogo.png');
                this.style.backgroundImage  = `url(${imgPath})`
                this.style.backgroundSize   = "30%";
                this.style.backgroundPosition = "center";
            }

            this.style.backgroundRepeat = "no-repeat";
            this.style.color            = "white";
            this.style.textAlign        = "center";    
            this.style.display          = "flex";
            this.style.flexDirection    = "column";
            this.style.lineHeight       = "120%";
            this.style.justifyContent   = "center";
            this.contentEditable = "false";

            //마스크 처리
            if(this.model.mask_use){
                this.style.webkitMaskPosition   = `${this.model.mask_left}% ${this.model.mask_top}%`;
                this.style.webkitMaskSize       = `${this.model.mask_width}% ${this.model.mask_height}%`;
                if(this.model.mask_repeat){
                    this.style.webkitMaskRepeat = "repeat";    
                }else{
                    this.style.webkitMaskRepeat = "no-repeat";    
                }
                if(this.model.mask_image.length > 0){
                    //https://cdn.icon-icons.com/icons2/692/PNG/512/seo-social-web-network-internet_132_icon-icons.com_61506.png
                    this.style.webkitMaskImage = `url(${this.model.mask_image})`;
                }else{
                    this.style.webkitMaskImage = "";    
                }
            }else{
                this.style.webkitMaskImage = "";
                this.style.webkitMaskPosition = "";
                this.style.webkitMaskSize = "";
            }

            /*
            if(this.model.movie instanceof File){
                this.innerText              = "MOVIE";
            }else if(this.model.movie != null && this.model.movie.length > 0){
                this.innerText              = "MOVIE";
            }else{
                this.innerText              = "Select Movie";
            }
            */

        }else if(this.model.component_type == Component_Model.COMPONENT_YOUTUBE){
            this.style.backgroundColor  = "black";
            this.style.backgroundImage  = "";

            this.style.color            = "white";
            this.style.textAlign        = "center";
            this.style.display          = "flex";
            this.style.flexDirection    = "column";
            this.style.alignItems       = "center";
            this.style.lineHeight       = "120%";
            this.style.justifyContent   = "center";
            this.contentEditable = "false";

            const imgPath = require('@/assets/youtubelogo.png');
            this.innerHTML = `<img src="${imgPath}" style="width:50%;" />
                <div style="margin-top:8px;font-size:13px;color:#ff6b6b;">YOUTUBE는 WINDOWS플레이어에서 작동하지 않습니다.</div>`;

        }else if(this.model.component_type == Component_Model.COMPONENT_WEBVIEW){
            
            if(this.model.weblink && this.model.weblink.length > 0) {
                this.style.backgroundColor  = "black";
                const imgPath = require('@/assets/homelogo.png');
                this.style.backgroundImage  = `url(${imgPath})`;
                this.style.backgroundSize   = "30%";
                this.style.backgroundPosition = "center";
                this.innerText = "";
            } else {
                this.innerHTML = `<div style="display: flex; align-items: center; justify-content: center; height: 100%; color: #999; font-size: 14px; border: 2px dashed #ddd; border-radius: 4px;">
                    <div style="text-align: center;">
                        <div style="font-size: 24px; margin-bottom: 8px;">🌐</div>
                        <div>웹뷰</div>
                    </div>
                </div>`;
            }

            this.style.backgroundRepeat = "no-repeat";
            this.style.color            = "white";
            this.style.textAlign        = "center";    
            this.style.display          = "flex";
            this.style.flexDirection    = "column";
            this.style.lineHeight       = "120%";
            this.style.justifyContent   = "center";
            this.contentEditable = "false";
        }else if(this.model.component_type == Component_Model.COMPONENT_ANITEST){
            //this.style.backgroundColor  = "black";

            const imgPath = require('@/assets/staricon2.svg');
            this.style.backgroundImage  = `url(${imgPath})`
            //this.style.backgroundSize   = "30%";
            this.style.backgroundPosition = "center";

            this.style.backgroundRepeat = "no-repeat";
            this.style.color            = "white";
            this.style.textAlign        = "center";    
            this.style.display          = "flex";
            this.style.flexDirection    = "column";
            this.style.lineHeight       = "120%";
            this.style.justifyContent   = "center";
            this.contentEditable = "false";

        }else if(this.model.component_type == Component_Model.COMPONENT_ANISHOW){
            //this.style.backgroundColor  = "black";
            
            this.onmouseover = null;    

            const imgPath = require('@/assets/star_icon2.svg');
            this.style.backgroundImage  = `url(${imgPath})`
            //this.style.backgroundSize   = "30%";
            this.style.backgroundPosition = "center";

            this.style.backgroundRepeat = "no-repeat";
            this.style.color            = "white";
            this.style.textAlign        = "center";    
            this.style.display          = "flex";
            this.style.flexDirection    = "column";
            this.style.lineHeight       = "120%";
            this.style.justifyContent   = "center";
            this.contentEditable = "false";

        }else if(this.model.component_type == Component_Model.COMPONENT_SOUND){
            
            if(this.model.sound && this.model.sound.length > 0) {
                this.style.backgroundColor  = "gray";
                const imgPath = require('@/assets/soundlogo.png');
                this.style.backgroundImage  = `url(${imgPath})`;
                this.style.backgroundSize   = "80%";
                this.style.backgroundPosition = "center";
                this.innerText = "";
            } else {
                this.innerHTML = `<div style="display: flex; align-items: center; justify-content: center; height: 100%; color: #999; font-size: 14px; border: 2px dashed #ddd; border-radius: 4px;">
                    <div style="text-align: center;">
                        <div style="font-size: 24px; margin-bottom: 8px;">🔊</div>
                        <div>사운드</div>
                    </div>
                </div>`;
            }

            this.style.backgroundRepeat = "no-repeat";
            this.style.color            = "white";
            this.style.textAlign        = "center";    
            this.style.display          = "flex";
            this.style.flexDirection    = "column";
            this.style.lineHeight       = "120%";
            this.style.justifyContent   = "center";
            this.contentEditable = "false";

        }else if(this.model.component_type == Component_Model.COMPONENT_API){
            
            if(this.model.apilink && this.model.apilink.length > 0) {
                this.style.backgroundColor  = "gray";
                const imgPath = require('@/assets/apilogo.png');
                this.style.backgroundImage  = `url(${imgPath})`;
                this.style.backgroundSize   = "80%";
                this.style.backgroundPosition = "center";
                this.innerText = "";
            } else {
                this.innerHTML = `<div style="display: flex; align-items: center; justify-content: center; height: 100%; color: #999; font-size: 14px; border: 2px dashed #ddd; border-radius: 4px;">
                    <div style="text-align: center;">
                        <div style="font-size: 24px; margin-bottom: 8px;">🔌</div>
                        <div>API</div>
                    </div>
                </div>`;
            }

            this.style.backgroundRepeat = "no-repeat";
            this.style.color            = "white";
            this.style.textAlign        = "center";    
            this.style.display          = "flex";
            this.style.flexDirection    = "column";
            this.style.lineHeight       = "120%";
            this.style.justifyContent   = "center";
            this.contentEditable = "false";

        }else if(this.model.component_type == Component_Model.COMPONENT_DATALOAD){
            
            this.innerHTML = `<div style="display: flex; align-items: center; justify-content: center; height: 100%; color: #999; font-size: 14px; border: 2px dashed #ddd; border-radius: 4px;">
                <div style="text-align: center;">
                    <div style="font-size: 24px; margin-bottom: 8px;">💾</div>
                    <div>DATA LOAD</div>
                </div>
            </div>`;
            
            this.style.backgroundRepeat = "no-repeat";
            this.style.color            = "white";
            this.style.textAlign        = "center";    
            this.style.display          = "flex";
            this.style.flexDirection    = "column";
            this.style.lineHeight       = "120%";
            this.style.justifyContent   = "center";
            this.contentEditable = "false";

        }else if(this.model.component_type == Component_Model.COMPONENT_TEXT_SCROLL){

            this.innerText          = this.model.text;
            this.style.fontFamily   = this.model.textfont;
            this.style.fontSize     = this.model.textsize+'px';
            this.style.color        = this.model.textcolor;
            this.style.textAlign    = "left ";    //left, center, right
            
            //텍스트 줄 바꿈 없음
            this.style.whiteSpace       = "nowrap"; 
            this.style.overflow         = "hidden";

            //텍스트 세로 정렬
            this.style.display          = "flex";
            this.style.flexDirection    = "column";
            this.style.lineHeight       = "120%";
            this.style.justifyContent   = this.model.textverti_align;       //top, center, end
            
            this.style.letterSpacing    = this.model.letterSpacing+"px" 
            this.style.lineHeight       = this.model.lineHeight+"%"     
            
            //언더라인
            if(this.model.textUnderline == 0){
                this.style.textDecoration = "none";
            }else{
                this.style.textDecoration = "underline";
            }
            
            //볼드
            if(this.model.textBold == 0){
                this.style.fontWeight = this.model.font_weight == null || this.model.font_weight.length == 0 ? "normal" : this.model.font_weight;
            }else{
                this.style.fontWeight = this.model.font_weight == null || this.model.font_weight.length == 0 ? "bold" : this.model.font_weight;
            }

            //이탤릭
            if(this.model.textItalic == 0){
                this.style.fontStyle = "normal";
            }else{
                this.style.fontStyle = "italic";
            }

            //input 텍스트처리 (더블클릭시)
            this.contentEditable = "true";

            //그림자 우측, 아래, 블러범위, 색상
            if(this.model.shadow_use){
                this.style.textShadow = `${this.model.shadow_hori}px ${this.model.shadow_verti}px ${this.model.shadow_blur}px ${this.model.shadow_color}`;    
            }

            if(this.model.outline_use){
                this.style.webkitTextStroke = `${this.model.outline_size}px ${this.model.outline_color}`;  
            }
                        

        }else if(this.model.component_type == Component_Model.COMPONENT_SVG){
            
            this.contentEditable = "false";
            
            // 컨테이너 기본 스타일 설정
            this.style.overflow = "hidden";
            this.style.position = "absolute";
            this.style.width = `${this.model.width}px`;
            this.style.height = `${this.model.height}px`;
            
            // SVG 상태가 변경되었는지 확인
            const svgStateChanged = 
                this.lastSVGPath !== this.model.svg_path ||
                this.lastSVGColor !== this.model.svg_fill_color ||
                this.lastSVGColorUse !== this.model.svg_color_use;
            
            const hasSVGContent = this.querySelector('svg') !== null;
            
            if(this.model.svg_path && this.model.svg_path.length > 0){
                // SVG가 없거나 상태가 변경된 경우 다시 로드
                if (!hasSVGContent || svgStateChanged) {
                    this.innerHTML = "";
                    this.loadSVGForEdit();
                    // 상태 저장
                    this.lastSVGPath = this.model.svg_path;
                    this.lastSVGColor = this.model.svg_fill_color;
                    this.lastSVGColorUse = this.model.svg_color_use;
                }
            } else {
                if (!hasSVGContent) {
                    this.innerHTML = `<div style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; color: #999; font-size: 14px; border: 2px dashed #ddd; border-radius: 4px; box-sizing: border-box;">
                        <div style="text-align: center;">
                            <div style="font-size: 24px; margin-bottom: 8px;">🎨</div>
                            <div>SVG</div>
                        </div>
                    </div>`;
                }
            }

            //그림자 처리 (SVG용 filter)
            if(this.model.shadow_use){
                this.style.filter = `drop-shadow(${this.model.shadow_hori}px ${this.model.shadow_verti}px ${this.model.shadow_blur}px ${this.model.shadow_color})`;    
            }else{
                this.style.filter = "";
            }

        }else if(this.model.component_type == Component_Model.COMPONENT_SHAPE){
            
            this.contentEditable = "false";
            
            // 컨테이너 기본 스타일 설정
            this.style.overflow = "hidden";
            this.style.position = "absolute";
            this.style.width = `${this.model.width}px`;
            this.style.height = `${this.model.height}px`;
            
            // Shape 기본값 설정
            if (!this.model.shape_type) {
                this.model.shape_type = "rectangle";
            }
            if (!this.model.shape_fill_color) {
                this.model.shape_fill_color = "#3B82F6";
            }
            if (this.model.shape_fill_alpha === undefined) {
                this.model.shape_fill_alpha = 1.0;
            }
            if (!this.model.shape_stroke_color) {
                this.model.shape_stroke_color = "#1E40AF";
            }
            if (this.model.shape_stroke_alpha === undefined) {
                this.model.shape_stroke_alpha = 1.0;
            }
            if (this.model.shape_stroke_width === undefined) {
                this.model.shape_stroke_width = 0;
            }
            if (this.model.shape_corner_radius === undefined) {
                this.model.shape_corner_radius = 0;
            }
            // Shape 각 모서리별 둥글기 기본값
            if (this.model.shape_corner_radius_tl === undefined) {
                this.model.shape_corner_radius_tl = 0;
            }
            if (this.model.shape_corner_radius_tr === undefined) {
                this.model.shape_corner_radius_tr = 0;
            }
            if (this.model.shape_corner_radius_bl === undefined) {
                this.model.shape_corner_radius_bl = 0;
            }
            if (this.model.shape_corner_radius_br === undefined) {
                this.model.shape_corner_radius_br = 0;
            }
            // 원 제어 기본값
            if (this.model.circle_start_angle === undefined) {
                this.model.circle_start_angle = 0;
            }
            if (this.model.circle_end_angle === undefined) {
                this.model.circle_end_angle = 360;
            }
            if (this.model.circle_inner_radius === undefined) {
                this.model.circle_inner_radius = 0;
            }
            // 다각형 기본값
            if (this.model.polygon_sides === undefined) {
                this.model.polygon_sides = 5;
            }
            if (this.model.polygon_corner_radius === undefined) {
                this.model.polygon_corner_radius = 0;
            }
            if (this.model.polygon_inner_radius === undefined || this.model.polygon_inner_radius === null) {
                this.model.polygon_inner_radius = 0;
            }
            
            // Shape 렌더링
            this.createShapeForEdit();

            //그림자 처리 (Shape용 filter)
            if(this.model.shadow_use){
                this.style.filter = `drop-shadow(${this.model.shadow_hori}px ${this.model.shadow_verti}px ${this.model.shadow_blur}px ${this.model.shadow_color})`;    
            }else{
                this.style.filter = "";
            }

        }

        //셀렉트 락처리
        this.checkLock();

    }


    //이미지 마스크 CORS 우회 처리
    loadMaskImageAsync(url: string): Promise<HTMLImageElement> {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "anonymous"; // CORS 정책 준수를 위해 필요
            img.onload = () => resolve(img);
            img.onerror = () => reject(new Error(`Failed to load image at ${url}`));
            img.src = url;
        });
    }

    convertImageToBase64(url: string): Promise<string> {
        return this.loadMaskImageAsync(url).then((img: HTMLImageElement) => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                throw new Error('Unable to get canvas context');
            }
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            return canvas.toDataURL('image/webp', 1);
        }).catch(error => {
            console.error("Error in converting image to Base64:", error);
            throw error;
        });
    }

    async loadSVGForEdit() {
        if (!this.model?.svg_path || this.model.svg_path.length === 0) {
            return;
        }

        try {
            let svgContent: string;
            
            if (this.model.svg_path.startsWith('data:image/svg+xml;base64,')) {
                svgContent = atob(this.model.svg_path.split(',')[1]);
            } else if (this.model.svg_path.toLowerCase().startsWith("http")) {
                const response = await fetch(this.model.svg_path);
                svgContent = await response.text();
            } else {
                const response = await fetch(this.model.svg_path);
                svgContent = await response.text();
            }

            if (this.model.svg_color_use) {
                svgContent = this.applySVGColorsForEdit(svgContent);
            }

            const svgElement = this.createSVGElementForEdit(svgContent);
            this.innerHTML = "";
            this.appendChild(svgElement);

        } catch (error) {
            console.error("SVG 로드 실패:", error);
            this.innerHTML = `<div style="display: flex; align-items: center; justify-content: center; height: 100%; color: #ff6b6b; font-size: 14px; border: 2px dashed #ff6b6b; border-radius: 4px;">
                <div style="text-align: center;">
                    <div style="font-size: 24px; margin-bottom: 8px;">⚠️</div>
                    <div>SVG 로드 실패</div>
                </div>
            </div>`;
        }
    }

    applySVGColorsForEdit(svgContent: string): string {
        let modifiedSvg = svgContent;
        
        if (this.model?.svg_color_use && this.model?.svg_fill_color) {
            const colorType = this.model.svg_color_type || "color";
            
            if (colorType === "gradient") {
                // 그라데이션 처리
                const gradientId = this.generateUniqueId('svg-gradient');
                const parsedGradient = this.parseCSSGradient(this.model.svg_fill_color);
                
                if (parsedGradient) {
                    const gradientType = parsedGradient.type === 'radial' ? 'radialGradient' : 'linearGradient';
                    let gradientAttrs = '';
                    
                    if (parsedGradient.type === 'radial') {
                        gradientAttrs = `cx="50%" cy="50%" r="50%"`;
                    } else {
                        // 선형 그라데이션 각도 처리
                        const angle = parsedGradient.angle || 0;
                        const radians = (angle * Math.PI) / 180;
                        const x1 = 50 + 50 * Math.cos(radians + Math.PI);
                        const y1 = 50 + 50 * Math.sin(radians + Math.PI);
                        const x2 = 50 + 50 * Math.cos(radians);
                        const y2 = 50 + 50 * Math.sin(radians);
                        gradientAttrs = `x1="${x1}%" y1="${y1}%" x2="${x2}%" y2="${y2}%"`;
                    }
                    
                    let gradientStops = '';
                    parsedGradient.stops.forEach(stop => {
                        gradientStops += `<stop offset="${stop.position}%" stop-color="${stop.color}"/>`;
                    });
                    
                    const gradientDef = `<defs><${gradientType} id="${gradientId}" ${gradientAttrs}>${gradientStops}</${gradientType}></defs>`;
                    
                    // SVG에 gradient defs 추가
                    modifiedSvg = modifiedSvg.replace(/<svg([^>]*)>/i, `<svg$1>${gradientDef}`);
                    
                    // fill 속성을 gradient URL로 변경
                    modifiedSvg = modifiedSvg.replace(/fill="[^"]*"/g, `fill="url(#${gradientId})"`);
                    modifiedSvg = modifiedSvg.replace(/style="fill:[^;"]*;?/g, `style="fill:url(#${gradientId});`);
                } else {
                    // 그라데이션 파싱 실패 시 단색으로 처리
                    modifiedSvg = modifiedSvg.replace(/fill="[^"]*"/g, `fill="${this.model.svg_fill_color}"`);
                    modifiedSvg = modifiedSvg.replace(/style="fill:[^;"]*;?/g, `style="fill:${this.model.svg_fill_color};`);
                }
            } else {
                // 단색 처리
                modifiedSvg = modifiedSvg.replace(/fill="[^"]*"/g, `fill="${this.model.svg_fill_color}"`);
                modifiedSvg = modifiedSvg.replace(/style="fill:[^;"]*;?/g, `style="fill:${this.model.svg_fill_color};`);
            }
        }
        
        return modifiedSvg;
    }

    createSVGElementForEdit(svgContent: string): SVGElement {
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(svgContent, "image/svg+xml");
        const svgElement = svgDoc.querySelector('svg') as SVGElement;
        
        if (svgElement) {
            // 기존 width, height 속성 제거 (viewBox는 유지)
            svgElement.removeAttribute('width');
            svgElement.removeAttribute('height');
            
            // 컨테이너 크기에 맞게 조정
            svgElement.style.width = "100%";
            svgElement.style.height = "100%";
            svgElement.style.display = "block";
            svgElement.style.pointerEvents = "none";
            svgElement.style.position = "relative";
            svgElement.setAttribute('preserveAspectRatio', 'xMidYMid meet');
            
            // viewBox가 없으면 기본값 설정
            if (!svgElement.getAttribute('viewBox')) {
                svgElement.setAttribute('viewBox', '0 0 100 100');
            }
        }
        
        return svgElement;
    }


    updateTransElement(){
        if(this.model == null || this.model == undefined){
            return;
        }
        
        // Shape(12)나 SVG(11) 컴포넌트가 아닌 경우에만 updateRender 호출
        if(this.model.component_type !== 12 && this.model.component_type !== 11) {
                 this.updateRender();
        }
        
        //this.style.cssText += "transform: translateX("+`${this.model.transx}px`+") translateY("+`${this.model.transy}px`+") rotate("+`${this.model.rotate}deg`+")";
        this.style.transform = `translateX(${this.model.transx}px) translateY(${this.model.transy}px) rotate(${this.model.rotate}deg)`;
    }

    updateTransElementAll(){
        if(this.model == null || this.model == undefined){
            return;
        }

        this.updateRender();

        this.style.width  = `${this.model.width}px`;
        this.style.height = `${this.model.height}px`;
        this.style.transform = `translateX(${this.model.transx}px) translateY(${this.model.transy}px) rotate(${this.model.rotate}deg)`;

        //this.style.cssText += "width:"+`${this.model.width}px`+"; height:"+`${this.model.height}px`+"; transform: translateX("+`${this.model.transx}px`+") translateY("+`${this.model.transy}px`+") rotate("+`${this.model.rotate}deg`+")";
        
    }


    //애니매이션
    playani(){
        if(this.model == null || this.model == undefined){
            return;
        }
        
        if(this.model.aniplaymodel == null || this.model.aniplaymodel == undefined){
            return;
        }

        if(this.model.aniplaymodel.anilist == null || this.model.aniplaymodel.anilist == undefined || this.model.aniplaymodel.anilist.length < 1){
            return;
        }

        if(this.timeline != null){
            this.timeline.kill();
            this.timeline.clear();
            this.timeline = null;
        }
        this.timeline = gsap.timeline({repeat:Number(this.model.aniplaymodel.repeat), repeatDelay:Number(this.model.aniplaymodel.repeatDelay), yoyo:Boolean(this.model.aniplaymodel.yoyo)});

        //애니의 좌표를 += 되는 개념이다. 나머지는 그냥 바로 해당 수치로 변경되면 된다.
        let move_posx   = Number(this.model.transx);
        let move_posy   = Number(this.model.transy);
        let move_rotate = Number(this.model.rotate);
        
        let move_rotatex = 0;
        let move_rotatey = 0;
        let move_skewx   = 0;
        let move_skewy   = 0;

        //초기위치 - 이건 애니매이션을 한 화면에서 여러번 재생하니깐 해주는거다. 실제 뷰어에서는 필요 없다.
        this.timeline.to(this, { duration:0, x:move_posx, y:move_posy
            , scaleX:1, scaleY:1
            , rotationX:move_rotatex, rotationY:move_rotatey, rotation:move_rotate
            , skewX:move_skewx, skewY:move_skewy        
            , alpha:this.model.alpha });

        this.model.aniplaymodel.anilist.forEach((ani, index)=>{
            move_posx += Number(ani.movex);
            move_posy += Number(ani.movey);
            move_rotate += Number(ani.rotate);
            move_rotatex += Number(ani.rotatex);
            move_rotatey += Number(ani.rotatey);
            move_skewx += Number(ani.skewx);
            move_skewy += Number(ani.skewy);

            //첫번째 인덱스의 딜레이는 항상 0으로 처리해야한다.
            const aniprop: {[key: string]: string|number} = { delay: ani.delay, duration:ani.duration, x:move_posx, y:move_posy
                                                            , scaleX:ani.scalex, scaleY:ani.scaley
                                                            , rotationX:move_rotatex, rotationY:move_rotatey, rotation:move_rotate
                                                            , skewX:move_skewx, skewY:move_skewy        
                                                            , alpha:ani.alpha, ease:`${ani.ease}.${ani.easetype}` 
                                                            , transformOrigin: `${ani.centerx}% ${ani.centery}%`};
            //추가 커스텀 속성처리
            ani.proplist.forEach(prop=>{
                aniprop[prop.propname] = prop.propvalue;
            });
            this.timeline!.to(this, aniprop);
        });        

        this.timeline.eventCallback("onComplete", ()=>{
            
            this.stopAni();
        });

    }

    //애니매이션
    playEffect(effect:Animation_Model){
        
        if(effect == null || effect == undefined){
            return;
        }

        const move_posx   = Number(this.model.transx) + Number(effect.movex);
        const move_posy   = Number(this.model.transy) + Number(effect.movey);
        const move_rotate = Number(this.model.rotate) + Number(effect.rotate);
  
        gsap.fromTo(this
          , {x:this.model.transx, y:this.model.transy, scale:1, rotate:this.model.rotate, alpha:this.model.alpha}
          , {delay:effect.delay, duration:effect.duration
            , x:move_posx, y:move_posy, scale:effect.scale, rotate:move_rotate
            , ease:`${effect.ease}.${effect.easetype}`
          }
        );

    }    

    //중지
    stopAni(){
        
        if(this.timeline != null){
            this.timeline.kill();
            this.timeline.clear();
            this.timeline.to(this, {x:this.model.transx, y:this.model.transy, scale:1, rotate:this.model.rotate, alpha:this.model.alpha, duration:0});

        }

    }


    /*******************************************************************************************************/
    //텍스트 편집 메서드
    /*******************************************************************************************************/

    onmouseover_event(e:MouseEvent){
        if(this.selectlock){
            this.style.outline = "none";
        }else{
            this.style.outline = "2px solid red";
        }
        
    }   

    onmouseout_event(e:MouseEvent){
        this.style.outline = "none";
    }

    onmousedown_event(e:MouseEvent){
        // 마우스 다운 이벤트 처리
    }

    onmouseup_event(e:MouseEvent){
        // 마우스 업 시에만 선택 이벤트 발생
        // 실제 드래그가 일어나지 않은 경우에만 선택
    }

    //컴포넌트 더블 클릭시
    event_doubleclick(e:MouseEvent){
        
        if(this.model == null || this.model == undefined){
            return;
        }
        //텍스트의 경우에는 포커스를 넣어서 수정하도록 한다.
        if(this.model.component_type == Component_Model.COMPONENT_TEXT || this.model.component_type == Component_Model.COMPONENT_ARTTEXT){
            e.preventDefault();
            this.style.pointerEvents = "auto";
            this.focus();
        }
    }
    //편집시 더블클릭으로 포커스를 넣은 후 키입력으로 텍스트 내용 변경
    onkeyupevent(evt:KeyboardEvent){
        //스페이스바 누르면 에디트모드/이동모드가 변경되기 때문에 부모에게 키이벤트 버블링 막기
        evt.stopPropagation();
        if(this.model == null || this.model == undefined){
            return;
        }
        if(this.model.component_type == Component_Model.COMPONENT_TEXT || this.model.component_type == Component_Model.COMPONENT_ARTTEXT){
            
            this.model.text = this.innerText;
        }
    }
    onkeydownevent(evt:KeyboardEvent){
        //스페이스바 누르면 에디트모드/이동모드가 변경되기 때문에 부모에게 키이벤트 버블링 막기
        evt.stopPropagation();
    }

    // Shape 생성 메서드
    createShapeForEdit() {
        if(!this.model) return;

        // 모든 경우를 SVG로 처리하여 테두리, 모서리 둥글기 등 지원
        const svgContent = this.generateShapeSVG();
        this.innerHTML = svgContent;
        
        // HTML 스타일 초기화
        this.style.background = '';
        this.style.clipPath = '';
        this.style.opacity = '';
    }
    
    // Shape 모양에 따른 clip-path 적용
    applyShapeClipPath() {
        if(!this.model) return;
        
        const shapeType = this.model.shape_type || "rectangle";
        
        switch(shapeType) {
            case "rectangle":
                // 모서리 둥글기 적용
                const radius = this.model.shape_corner_radius || 0;
                this.style.borderRadius = `${radius}px`;
                this.style.clipPath = '';
                break;
                
            case "circle":
                this.style.clipPath = 'ellipse(50% 50% at 50% 50%)';
                this.style.borderRadius = '';
                break;
                
            case "triangle":
                this.style.clipPath = 'polygon(50% 0%, 0% 100%, 100% 100%)';
                this.style.borderRadius = '';
                break;
                
            default:
                this.style.clipPath = '';
                this.style.borderRadius = '';
        }
    }

    generateShapeSVG(): string {
        if(!this.model) return "";

        const width = this.model.width;
        const height = this.model.height;
        const fillType = this.model.shape_fill_type || "color";
        const fillColor = this.model.shape_fill_color || "#3B82F6";
        const fillImage = this.model.shape_fill_image || "";
        const fillAlpha = this.model.shape_fill_alpha !== undefined ? this.model.shape_fill_alpha : 1.0;
        
        const strokeColor = this.model.shape_stroke_color || "#1E40AF";
        const strokeAlpha = this.model.shape_stroke_alpha !== undefined ? this.model.shape_stroke_alpha : 1.0;
        const strokeWidth = this.model.shape_stroke_width || 0;

        // RGBA 색상 생성 함수
        const hexToRgba = (hex: string, alpha: number): string => {
            const r = parseInt(hex.slice(1, 3), 16);
            const g = parseInt(hex.slice(3, 5), 16);
            const b = parseInt(hex.slice(5, 7), 16);
            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        };

        // Fill 설정 - 색상, 그라데이션, 이미지
        let finalFillColor: string;
        let defsContent = "";
        
        if (fillType === "image" && fillImage) {
            const patternId = this.generateUniqueId('image-pattern');
            const imageFit = this.model.shape_image_fit || "cover";
            const imagePositionX = this.model.shape_image_position_x !== undefined ? this.model.shape_image_position_x : 50;
            const imagePositionY = this.model.shape_image_position_y !== undefined ? this.model.shape_image_position_y : 50;
            const imageScale = this.model.shape_image_scale !== undefined ? this.model.shape_image_scale : 100;
            const imageRepeat = this.model.shape_image_repeat || false;

            // 이미지 크기 및 위치 계산
            const scaleRatio = imageScale / 100;
            const imageWidth = width * scaleRatio;
            const imageHeight = height * scaleRatio;
            const imageX = (width - imageWidth) * (imagePositionX / 100);
            const imageY = (height - imageHeight) * (imagePositionY / 100);

            // preserveAspectRatio 설정
            let preserveAspectRatio = "xMidYMid slice";
            switch(imageFit) {
                case "cover":
                    preserveAspectRatio = "xMidYMid slice";
                    break;
                case "contain":
                    preserveAspectRatio = "xMidYMid meet";
                    break;
                case "fill":
                    preserveAspectRatio = "none";
                    break;
                case "none":
                    preserveAspectRatio = "none";
                    break;
            }

            // 패턴 크기 설정 (반복용)
            const patternWidth = imageRepeat ? (imageWidth / width) : 1;
            const patternHeight = imageRepeat ? (imageHeight / height) : 1;

            defsContent = `<defs>
                <pattern id="${patternId}" patternUnits="objectBoundingBox" 
                         width="${patternWidth}" height="${patternHeight}">
                    <image href="${fillImage}" 
                           x="${imageX}" y="${imageY}" 
                           width="${imageWidth}" height="${imageHeight}" 
                           preserveAspectRatio="${preserveAspectRatio}" 
                           opacity="${fillAlpha}"
                           pointer-events="none"
                           style="pointer-events: none !important; user-select: none; -webkit-user-select: none;"/>
                </pattern>
            </defs>`;
            finalFillColor = `url(#${patternId})`;
        } else if (fillType === "gradient") {
            const gradientId = this.generateUniqueId('gradient');
            const parsedGradient = this.parseCSSGradient(fillColor);
            
            if (parsedGradient) {
                const gradientType = parsedGradient.type === 'radial' ? 'radialGradient' : 'linearGradient';
                let gradientAttrs = '';
                
                if (parsedGradient.type === 'radial') {
                    gradientAttrs = `cx="50%" cy="50%" r="50%"`;
                } else {
                    // 선형 그라데이션 각도 처리
                    const angle = parsedGradient.angle || 180;
                    const radians = ((angle - 90) * Math.PI) / 180;
                    const x1 = 50 + 50 * Math.cos(radians + Math.PI);
                    const y1 = 50 + 50 * Math.sin(radians + Math.PI);
                    const x2 = 50 + 50 * Math.cos(radians);
                    const y2 = 50 + 50 * Math.sin(radians);
                    gradientAttrs = `x1="${x1}%" y1="${y1}%" x2="${x2}%" y2="${y2}%"`;
                }
                
                let gradientStops = '';
                parsedGradient.stops.forEach(stop => {
                    gradientStops += `<stop offset="${stop.position}%" stop-color="${stop.color}"/>`;
                });
                
                defsContent = `<defs>
                    <${gradientType} id="${gradientId}" ${gradientAttrs}>
                        ${gradientStops}
                    </${gradientType}>
                </defs>`;
                finalFillColor = `url(#${gradientId})`;
            } else {
                finalFillColor = hexToRgba(fillColor, fillAlpha);
            }
            
        } else {
            // 일반 색상 처리 - alpha 값 적용
            if (typeof fillColor === 'string' && fillColor.startsWith('#') && fillColor.length === 9) {
                // 8자리 hex 색상 (alpha 포함)
                const r = parseInt(fillColor.slice(1, 3), 16) || 0;
                const g = parseInt(fillColor.slice(3, 5), 16) || 0;
                const b = parseInt(fillColor.slice(5, 7), 16) || 0;
                const a = parseInt(fillColor.slice(7, 9), 16) / 255;
                finalFillColor = `rgba(${r}, ${g}, ${b}, ${a})`;
            } else {
                finalFillColor = hexToRgba(fillColor, fillAlpha);
            }
        }
        
        // 테두리 색상 처리 (단색/그라데이션)
        let finalStrokeColor = 'none';
        if (strokeWidth > 0) {
            const strokeType = this.model.shape_stroke_type || "color";
            
            if (strokeType === "gradient") {
                // 그라데이션 처리
                const gradientId = this.generateUniqueId('stroke-gradient');
                const parsedGradient = this.parseCSSGradient(strokeColor);
                
                if (parsedGradient) {
                    const gradientType = parsedGradient.type === 'radial' ? 'radialGradient' : 'linearGradient';
                    let gradientAttrs = '';
                    
                    if (parsedGradient.type === 'radial') {
                        gradientAttrs = `cx="50%" cy="50%" r="50%"`;
                    } else {
                        // 선형 그라데이션 각도 처리
                        const angle = parsedGradient.angle || 180;
                        const radians = ((angle - 90) * Math.PI) / 180;
                        const x1 = 50 + 50 * Math.cos(radians + Math.PI);
                        const y1 = 50 + 50 * Math.sin(radians + Math.PI);
                        const x2 = 50 + 50 * Math.cos(radians);
                        const y2 = 50 + 50 * Math.sin(radians);
                        gradientAttrs = `x1="${x1}%" y1="${y1}%" x2="${x2}%" y2="${y2}%"`;
                    }
                    
                    let gradientStops = '';
                    parsedGradient.stops.forEach(stop => {
                        gradientStops += `<stop offset="${stop.position}%" stop-color="${stop.color}"/>`;
                    });
                    
                    const strokeGradientDef = `<${gradientType} id="${gradientId}" ${gradientAttrs} gradientUnits="userSpaceOnUse">
                        ${gradientStops}
                    </${gradientType}>`;
                    
                    // 기존 defsContent에 추가
                    if (defsContent.includes('<defs>')) {
                        defsContent = defsContent.replace('</defs>', `${strokeGradientDef}</defs>`);
                    } else {
                        defsContent = `<defs>${strokeGradientDef}</defs>`;
                    }
                    
                    finalStrokeColor = `url(#${gradientId})`;
                } else {
                    finalStrokeColor = hexToRgba(strokeColor, strokeAlpha);
                }
            } else {
                finalStrokeColor = strokeColor;
            }
        }

        let shapeElement = "";
        
        // stroke opacity 속성 미리 계산 (모든 도형에서 공통 사용)
        const strokeOpacityAttr = this.model.shape_stroke_type === "gradient" ? "" : ` stroke-opacity="${strokeAlpha}"`;
        
        switch(this.model.shape_type) {
            case "rectangle":
                const rectWidth = Math.max(0, width - strokeWidth);
                const rectHeight = Math.max(0, height - strokeWidth);
                
                // 각 모서리별 둥글기 체크
                const baseRadius = this.model.shape_corner_radius || 0;
                const tl = this.model.shape_corner_radius_tl !== undefined ? this.model.shape_corner_radius_tl : baseRadius;
                const tr = this.model.shape_corner_radius_tr !== undefined ? this.model.shape_corner_radius_tr : baseRadius;
                const bl = this.model.shape_corner_radius_bl !== undefined ? this.model.shape_corner_radius_bl : baseRadius;
                const br = this.model.shape_corner_radius_br !== undefined ? this.model.shape_corner_radius_br : baseRadius;
                
                const hasSeparateRadius = tl > 0 || tr > 0 || bl > 0 || br > 0;
                
                if (hasSeparateRadius) {
                    // path를 사용해서 각 모서리별 둥글기 적용
                    const pathData = this.generateRectanglePath(strokeWidth/2, strokeWidth/2, rectWidth, rectHeight, tl, tr, bl, br);
                    shapeElement = `<path d="${pathData}"
                                        fill="${finalFillColor}" 
                                        stroke="${finalStrokeColor}" 
                                        stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
                } else {
                    // 기본 rect 사용 (호환성)
                    const rx = this.model.shape_corner_radius || 0;
                    shapeElement = `<rect x="${strokeWidth/2}" y="${strokeWidth/2}" 
                                        width="${rectWidth}" height="${rectHeight}" 
                                        rx="${rx}" ry="${rx}"
                                        fill="${finalFillColor}" 
                                        stroke="${finalStrokeColor}" 
                                        stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
                }
                break;
                
            case "circle":
                // 타원(Ellipse) - 너비와 높이에 맞춰 그리기
                const radiusX = Math.max(0, (width - strokeWidth) / 2);
                const radiusY = Math.max(0, (height - strokeWidth) / 2);
                const cx = width / 2;
                const cy = height / 2;
                
                // 원 제어 속성 기본값 설정
                const startAngle = this.model.circle_start_angle !== undefined ? this.model.circle_start_angle : 0;
                const endAngle = this.model.circle_end_angle !== undefined ? this.model.circle_end_angle : 360;
                const innerRadiusRatio = this.model.circle_inner_radius !== undefined ? this.model.circle_inner_radius : 0;
                
                // 완전한 타원인지 확인
                const isFullEllipse = (endAngle - startAngle) % 360 === 0;
                const isDonut = innerRadiusRatio > 0;
                
                if (isFullEllipse && !isDonut) {
                    // 기본 완전한 타원 (ellipse 태그 사용)
                    shapeElement = `<ellipse cx="${cx}" cy="${cy}" rx="${radiusX}" ry="${radiusY}"
                                        fill="${finalFillColor}" 
                                        stroke="${finalStrokeColor}" 
                                        stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
                } else {
                    // Arc, Pie, Donut을 위한 path 생성 (타원 기준)
                    const pathData = this.generateEllipsePath(cx, cy, radiusX, radiusY, startAngle, endAngle, innerRadiusRatio);
                    shapeElement = `<path d="${pathData}"
                                        fill="${finalFillColor}" 
                                        stroke="${finalStrokeColor}" 
                                        stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
                }
                break;
                
            case "polygon":
                // 다각형 생성 (polygon_sides 값에 따른 동적 다각형)
                const polygonSides = this.model.polygon_sides || 5;
                const polygonCornerRadius = this.model.polygon_corner_radius || 0;
                const polygonInnerRadius = this.model.polygon_inner_radius || 0;
                
                if (polygonCornerRadius > 0) {
                    // 모서리 둥글기가 있는 경우 path 사용
                    const pathData = this.generatePolygonPath(width, height, polygonSides, strokeWidth, polygonCornerRadius, polygonInnerRadius);
                    shapeElement = `<path d="${pathData}"
                                        fill="${finalFillColor}" 
                                        stroke="${finalStrokeColor}" 
                                        stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
                } else {
                    // 기본 polygon 사용
                    const polygonPoints = this.generatePolygonPoints(width, height, polygonSides, strokeWidth, polygonInnerRadius);
                    shapeElement = `<polygon points="${polygonPoints}"
                                        fill="${finalFillColor}" 
                                        stroke="${finalStrokeColor}" 
                                        stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
                }
                break;
                
            case "line":
                // 선 그리기
                // eslint-disable-next-line no-case-declarations
                const lineThickness = this.model.line_thickness || 2;
                const lineColorType = this.model.line_color_type || "color";
                const lineColor = this.model.line_color || "#000000";
                const lineAlpha = this.model.line_alpha !== undefined ? this.model.line_alpha : 1.0;
                const startCap = this.model.line_start_cap || "round";
                const endCap = this.model.line_end_cap || "round";
                
                let finalLineColor: string;
                
                if (lineColorType === "gradient") {
                    // 그라데이션 처리 - 다른 도형들과 동일한 방식
                    const gradientId = this.generateUniqueId('gradient');
                    const parsedGradient = this.parseCSSGradient(lineColor);
                    
                    if (parsedGradient) {
                        const gradientType = parsedGradient.type === 'radial' ? 'radialGradient' : 'linearGradient';
                        let gradientAttrs = '';
                        
                        if (parsedGradient.type === 'radial') {
                            gradientAttrs = `cx="50%" cy="50%" r="50%"`;
                        } else {
                            // 선형 그라데이션 각도 처리 - 다른 도형들과 동일
                            const angle = parsedGradient.angle || 180;
                            const radians = ((angle - 90) * Math.PI) / 180;
                            const x1 = 50 + 50 * Math.cos(radians + Math.PI);
                            const y1 = 50 + 50 * Math.sin(radians + Math.PI);
                            const x2 = 50 + 50 * Math.cos(radians);
                            const y2 = 50 + 50 * Math.sin(radians);
                            gradientAttrs = `x1="${x1}%" y1="${y1}%" x2="${x2}%" y2="${y2}%"`;
                        }
                        
                        let gradientStops = '';
                        parsedGradient.stops.forEach(stop => {
                            gradientStops += `<stop offset="${stop.position}%" stop-color="${stop.color}"/>`;
                        });
                        
                        defsContent = `<defs>
                            <${gradientType} id="${gradientId}" ${gradientAttrs} gradientUnits="userSpaceOnUse">
                                ${gradientStops}
                            </${gradientType}>
                        </defs>`;
                        finalLineColor = `url(#${gradientId})`;
                    } else {
                        finalLineColor = lineColor;
                    }
                } else {
                    finalLineColor = lineColor;
                }
                
                // 선의 시작점과 끝점 (컴포넌트 영역 전체를 가로지르는 수평선)
                const x1 = lineThickness / 2;
                const y1 = height / 2;
                const x2 = width - lineThickness / 2;
                const y2 = height / 2;
                
                // 그라데이션일 때는 opacity 없이, 단색일 때는 opacity 적용
                const opacityAttr = lineColorType === "gradient" ? "" : ` opacity="${lineAlpha}"`;
                
                // 시작점과 끝점이 같으면 기본 line 엘리먼트 사용
                if (startCap === endCap) {
                    shapeElement = `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}"
                                        stroke="${finalLineColor}"
                                        stroke-width="${lineThickness}"
                                        stroke-linecap="${startCap}"${opacityAttr}/>`;
                } else {
                    // 시작점과 끝점이 다르면 path로 그리기
                    const halfThickness = lineThickness / 2;
                    
                    // 기본 라인 경로
                    let pathData = `M ${x1} ${y1} L ${x2} ${y2}`;
                    
                    // 시작점 캡 추가
                    if (startCap === "round") {
                        pathData = `M ${x1} ${y1 - halfThickness} A ${halfThickness} ${halfThickness} 0 0 1 ${x1} ${y1 + halfThickness} L ${x1} ${y1} L ${x2} ${y2}`;
                    }
                    
                    // 끝점 캡 추가
                    if (endCap === "round") {
                        if (startCap === "round") {
                            pathData = `M ${x1} ${y1 - halfThickness} A ${halfThickness} ${halfThickness} 0 0 1 ${x1} ${y1 + halfThickness} L ${x2} ${y2 + halfThickness} A ${halfThickness} ${halfThickness} 0 0 1 ${x2} ${y2 - halfThickness} L ${x1} ${y1 - halfThickness} Z`;
                        } else {
                            pathData = `M ${x1} ${y1 - halfThickness} L ${x2} ${y2 - halfThickness} A ${halfThickness} ${halfThickness} 0 0 1 ${x2} ${y2 + halfThickness} L ${x1} ${y1 + halfThickness} Z`;
                        }
                    } else {
                        // butt 끝점인 경우
                        if (startCap === "round") {
                            pathData = `M ${x1} ${y1 - halfThickness} A ${halfThickness} ${halfThickness} 0 0 1 ${x1} ${y1 + halfThickness} L ${x2} ${y2 + halfThickness} L ${x2} ${y2 - halfThickness} Z`;
                        } else {
                            // 둘 다 butt인 경우는 위에서 처리됨
                            pathData = `M ${x1} ${y1 - halfThickness} L ${x2} ${y2 - halfThickness} L ${x2} ${y2 + halfThickness} L ${x1} ${y1 + halfThickness} Z`;
                        }
                    }
                    
                    shapeElement = `<path d="${pathData}"
                                        fill="${finalLineColor}"${opacityAttr}/>`;
                }
                break;
                
            default:
                // 기본값은 사각형
                const defaultWidth = Math.max(0, width - strokeWidth);
                const defaultHeight = Math.max(0, height - strokeWidth);
                shapeElement = `<rect x="${strokeWidth/2}" y="${strokeWidth/2}" 
                                    width="${defaultWidth}" height="${defaultHeight}" 
                                    fill="${finalFillColor}" 
                                    stroke="${finalStrokeColor}" 
                                    stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
        }

        return `<svg xmlns="http://www.w3.org/2000/svg" 
                    width="100%" height="100%" 
                    viewBox="0 0 ${width} ${height}"
                    style="display: block; pointer-events: none;">
                    ${defsContent}
                    ${shapeElement}
                    <!-- 투명한 오버레이로 마우스 이벤트 차단 -->
                    <rect x="0" y="0" width="100%" height="100%" 
                          fill="transparent" 
                          pointer-events="none" 
                          style="pointer-events: none !important;"/>
                </svg>`;
    }

    // 타원의 Arc, Pie, Donut path 생성 - 피그마 스타일
    generateEllipsePath(cx: number, cy: number, radiusX: number, radiusY: number, startAngle: number, endAngle: number, innerRadiusRatio: number): string {
        // 각도를 라디안으로 변환 (SVG는 12시 방향이 -90도)
        const startRad = ((startAngle - 90) * Math.PI) / 180;
        const endRad = ((endAngle - 90) * Math.PI) / 180;
        
        // 외부 타원의 시작점과 끝점
        const x1 = cx + radiusX * Math.cos(startRad);
        const y1 = cy + radiusY * Math.sin(startRad);
        const x2 = cx + radiusX * Math.cos(endRad);
        const y2 = cy + radiusY * Math.sin(endRad);
        
        // 호의 각도가 180도보다 큰지 확인
        const largeArcFlag = (endAngle - startAngle) % 360 > 180 ? 1 : 0;
        
        let pathData = "";
        
        if (innerRadiusRatio > 0) {
            // Donut 모양 (타원형)
            const innerRadiusX = radiusX * innerRadiusRatio;
            const innerRadiusY = radiusY * innerRadiusRatio;
            const ix1 = cx + innerRadiusX * Math.cos(startRad);
            const iy1 = cy + innerRadiusY * Math.sin(startRad);
            const ix2 = cx + innerRadiusX * Math.cos(endRad);
            const iy2 = cy + innerRadiusY * Math.sin(endRad);
            
            if ((endAngle - startAngle) % 360 === 0) {
                // 완전한 타원형 도넛
                pathData = `M ${cx + radiusX} ${cy} 
                           A ${radiusX} ${radiusY} 0 1 1 ${cx - radiusX} ${cy}
                           A ${radiusX} ${radiusY} 0 1 1 ${cx + radiusX} ${cy}
                           Z
                           M ${cx + innerRadiusX} ${cy}
                           A ${innerRadiusX} ${innerRadiusY} 0 1 0 ${cx - innerRadiusX} ${cy}
                           A ${innerRadiusX} ${innerRadiusY} 0 1 0 ${cx + innerRadiusX} ${cy}
                           Z`;
            } else {
                // 부채꼴 타원형 도넛
                pathData = `M ${x1} ${y1}
                           A ${radiusX} ${radiusY} 0 ${largeArcFlag} 1 ${x2} ${y2}
                           L ${ix2} ${iy2}
                           A ${innerRadiusX} ${innerRadiusY} 0 ${largeArcFlag} 0 ${ix1} ${iy1}
                           Z`;
            }
        } else {
            // Arc 또는 Pie (타원형)
            if ((endAngle - startAngle) % 360 === 0) {
                // 완전한 타원 (이 경우는 위에서 처리되지만 안전장치)
                pathData = `M ${cx + radiusX} ${cy} 
                           A ${radiusX} ${radiusY} 0 1 1 ${cx - radiusX} ${cy}
                           A ${radiusX} ${radiusY} 0 1 1 ${cx + radiusX} ${cy}
                           Z`;
            } else {
                // Pie 모양 (중심에서 시작, 타원형)
                pathData = `M ${cx} ${cy}
                           L ${x1} ${y1}
                           A ${radiusX} ${radiusY} 0 ${largeArcFlag} 1 ${x2} ${y2}
                           Z`;
            }
        }
        
        return pathData;
    }

    // 다각형/별 좌표 생성 메서드 (내부 반지름 지원)
    generatePolygonPoints(width: number, height: number, sides: number, strokeWidth: number, innerRadius: number = 0): string {
        const centerX = width / 2;
        const centerY = height / 2;
        
        // Shape 영역에 완전히 fit하도록 반지름 계산
        const margin = strokeWidth / 2;
        const availableWidth = width - strokeWidth;
        const availableHeight = height - strokeWidth;
        
        // 다각형이 완전히 들어갈 수 있는 최대 반지름 계산
        let maxRadiusX = availableWidth / 2;
        let maxRadiusY = availableHeight / 2;
        
        // 삼각형의 경우 특별 처리 - 정삼각형이 영역에 완전히 fit하도록
        if (sides === 3) {
            // 정삼각형의 높이는 (밑변 * √3) / 2
            // 영역에 fit하려면: 높이 = availableHeight, 밑변 = availableWidth
            // 반지름은 밑변의 1/3 (외접원의 반지름)
            const maxRadiusByHeight = (availableHeight * 2) / 3; // 높이 기준 반지름
            const maxRadiusByWidth = availableWidth / 2; // 너비 기준 반지름
            
            // 둘 중 작은 값 사용하여 영역을 벗어나지 않도록
            const fitRadius = Math.min(maxRadiusByHeight, maxRadiusByWidth);
            maxRadiusX = fitRadius;
            maxRadiusY = fitRadius;
        }
        
        const outerRadiusX = Math.max(0, maxRadiusX);
        const outerRadiusY = Math.max(0, maxRadiusY);
        const innerRadiusX = outerRadiusX * innerRadius;
        const innerRadiusY = outerRadiusY * innerRadius;
        
        const points: string[] = [];
        
        if (innerRadius > 0 && innerRadius !== undefined && innerRadius !== null) {
            // 별 모양: 외부 꼭짓점과 내부 꼭짓점 번갈아가며 생성
            for (let i = 0; i < sides * 2; i++) {
                const angle = (i * Math.PI / sides) - (Math.PI / 2); // -90도 회전 (12시 방향 시작)
                const isOuter = i % 2 === 0;
                const radiusX = isOuter ? outerRadiusX : innerRadiusX;
                const radiusY = isOuter ? outerRadiusY : innerRadiusY;
                const x = centerX + radiusX * Math.cos(angle);
                const y = centerY + radiusY * Math.sin(angle);
                points.push(`${x.toFixed(2)},${y.toFixed(2)}`);
            }
        } else {
            // 기본 다각형: 외부 꼭짓점만
            for (let i = 0; i < sides; i++) {
                const angle = (i * 2 * Math.PI / sides) - (Math.PI / 2); // -90도 회전 (12시 방향 시작)
                const x = centerX + outerRadiusX * Math.cos(angle);
                const y = centerY + outerRadiusY * Math.sin(angle);
                points.push(`${x.toFixed(2)},${y.toFixed(2)}`);
            }
        }
        
        return points.join(' ');
    }

    // 모서리 둥글기가 적용된 다각형/별 path 생성
    generatePolygonPath(width: number, height: number, sides: number, strokeWidth: number, cornerRadius: number, innerRadius: number = 0): string {
        const centerX = width / 2;
        const centerY = height / 2;
        
        // Shape 영역에 완전히 fit하도록 반지름 계산
        const availableWidth = width - strokeWidth;
        const availableHeight = height - strokeWidth;
        
        // 다각형이 완전히 들어갈 수 있는 최대 반지름 계산
        let maxRadiusX = availableWidth / 2;
        let maxRadiusY = availableHeight / 2;
        
        // 삼각형의 경우 특별 처리 - 정삼각형이 영역에 완전히 fit하도록
        if (sides === 3) {
            // 정삼각형의 높이는 (밑변 * √3) / 2
            // 영역에 fit하려면: 높이 = availableHeight, 밑변 = availableWidth
            // 반지름은 밑변의 1/3 (외접원의 반지름)
            const maxRadiusByHeight = (availableHeight * 2) / 3; // 높이 기준 반지름
            const maxRadiusByWidth = availableWidth / 2; // 너비 기준 반지름
            
            // 둘 중 작은 값 사용하여 영역을 벗어나지 않도록
            const fitRadius = Math.min(maxRadiusByHeight, maxRadiusByWidth);
            maxRadiusX = fitRadius;
            maxRadiusY = fitRadius;
        }
        
        const outerRadiusX = Math.max(0, maxRadiusX);
        const outerRadiusY = Math.max(0, maxRadiusY);
        const innerRadiusX = outerRadiusX * innerRadius;
        const innerRadiusY = outerRadiusY * innerRadius;
        
        const vertices: {x: number, y: number}[] = [];
        
        if (innerRadius > 0 && innerRadius !== undefined && innerRadius !== null) {
            // 별 모양: 외부 꼭짓점과 내부 꼭짓점 번갈아가며 생성
            for (let i = 0; i < sides * 2; i++) {
                const angle = (i * Math.PI / sides) - (Math.PI / 2);
                const isOuter = i % 2 === 0;
                const radiusX = isOuter ? outerRadiusX : innerRadiusX;
                const radiusY = isOuter ? outerRadiusY : innerRadiusY;
                const x = centerX + radiusX * Math.cos(angle);
                const y = centerY + radiusY * Math.sin(angle);
                vertices.push({x, y});
            }
        } else {
            // 기본 다각형: 외부 꼭짓점만
            for (let i = 0; i < sides; i++) {
                const angle = (i * 2 * Math.PI / sides) - (Math.PI / 2);
                const x = centerX + outerRadiusX * Math.cos(angle);
                const y = centerY + outerRadiusY * Math.sin(angle);
                vertices.push({x, y});
            }
        }
        
        if (vertices.length < 3) return "";
        
        let pathData = "";
        
        for (let i = 0; i < vertices.length; i++) {
            const current = vertices[i];
            const next = vertices[(i + 1) % vertices.length];
            const prev = vertices[(i - 1 + vertices.length) % vertices.length];
            
            // 벡터 계산
            const dx1 = current.x - prev.x;
            const dy1 = current.y - prev.y;
            const dx2 = next.x - current.x;
            const dy2 = next.y - current.y;
            
            // 벡터 길이
            const len1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
            const len2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
            
            if (len1 === 0 || len2 === 0) continue;
            
            // 단위 벡터
            const ux1 = dx1 / len1;
            const uy1 = dy1 / len1;
            const ux2 = dx2 / len2;
            const uy2 = dy2 / len2;
            
            // 모서리 둥글기 적용 거리 계산
            const maxRadius = Math.min(len1, len2) / 2;
            const actualRadius = Math.min(cornerRadius, maxRadius);
            
            // 둥글기 시작/끝점
            const startX = current.x - ux1 * actualRadius;
            const startY = current.y - uy1 * actualRadius;
            const endX = current.x + ux2 * actualRadius;
            const endY = current.y + uy2 * actualRadius;
            
            if (i === 0) {
                pathData += `M ${startX.toFixed(2)} ${startY.toFixed(2)}`;
            } else {
                pathData += ` L ${startX.toFixed(2)} ${startY.toFixed(2)}`;
            }
            
            if (actualRadius > 0) {
                pathData += ` Q ${current.x.toFixed(2)} ${current.y.toFixed(2)} ${endX.toFixed(2)} ${endY.toFixed(2)}`;
            }
        }
        
        pathData += " Z";
        return pathData;
    }

    // 각 모서리별 둥글기가 적용된 사각형 path 생성
    generateRectanglePath(x: number, y: number, width: number, height: number, tl: number, tr: number, bl: number, br: number): string {
        // 모서리 둥글기가 너무 크면 제한
        const maxRadius = Math.min(width, height) / 2;
        tl = Math.min(tl, maxRadius);
        tr = Math.min(tr, maxRadius);
        bl = Math.min(bl, maxRadius);
        br = Math.min(br, maxRadius);

        return `M ${x + tl},${y}
                L ${x + width - tr},${y}
                ${tr > 0 ? `Q ${x + width},${y} ${x + width},${y + tr}` : `L ${x + width},${y}`}
                L ${x + width},${y + height - br}
                ${br > 0 ? `Q ${x + width},${y + height} ${x + width - br},${y + height}` : `L ${x + width},${y + height}`}
                L ${x + bl},${y + height}
                ${bl > 0 ? `Q ${x},${y + height} ${x},${y + height - bl}` : `L ${x},${y + height}`}
                L ${x},${y + tl}
                ${tl > 0 ? `Q ${x},${y} ${x + tl},${y}` : `L ${x},${y}`}
                Z`;
    }

    // CSS 그라데이션 문자열을 파싱하는 메서드
    parseCSSGradient(cssGradient: string): { type: string, angle?: number, stops: Array<{color: string, position: number}> } | null {
        try {
            // linear-gradient 또는 radial-gradient 추출
            const isRadial = cssGradient.includes('radial-gradient');
            const type = isRadial ? 'radial' : 'linear';
            
            // 괄호 안의 내용 추출
            const match = cssGradient.match(/(?:linear|radial)-gradient\((.+)\)$/);
            if (!match) return null;
            
            const content = match[1];
            
            // 색상 stop들을 정확하게 분리하기 위해 더 정교한 방법 사용
            // 예: 135deg, rgb(240, 147, 251) 0%, rgb(245, 87, 108) 100%
            const colorStops: Array<{color: string, position: number}> = [];
            let angle = 180;
            
            // 각도 추출
            const angleMatch = content.match(/(\d+)deg/);
            if (angleMatch) {
                angle = parseInt(angleMatch[1]);
            }
            
            // 색상 stop 추출 - RGB, RGBA, HEX 형식 모두 지원
            
            // 1. RGB/RGBA 형식 추출
            const rgbaRegex = /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*([\d.]+))?\s*\)\s*(\d+)%/g;
            let colorMatch;
            while ((colorMatch = rgbaRegex.exec(content)) !== null) {
                const r = colorMatch[1];
                const g = colorMatch[2];
                const b = colorMatch[3];
                const a = colorMatch[4]; // 알파값 (없을 수도 있음)
                const position = parseInt(colorMatch[5]);
                
                const color = a !== undefined ? `rgba(${r}, ${g}, ${b}, ${a})` : `rgb(${r}, ${g}, ${b})`;
                colorStops.push({ color, position });
            }
            
            // 2. HEX 형식 추출 (#RRGGBB 또는 #RRGGBBAA)
            const hexRegex = /#([0-9a-fA-F]{6}([0-9a-fA-F]{2})?)\s*(\d+)%/g;
            let hexMatch;
            while ((hexMatch = hexRegex.exec(content)) !== null) {
                const hex = hexMatch[1];
                const position = parseInt(hexMatch[3]);
                
                // HEX를 RGB로 변환
                const r = parseInt(hex.slice(0, 2), 16);
                const g = parseInt(hex.slice(2, 4), 16);
                const b = parseInt(hex.slice(4, 6), 16);
                
                let color;
                if (hex.length === 8) {
                    // 알파값이 있는 경우
                    const a = parseInt(hex.slice(6, 8), 16) / 255;
                    color = `rgba(${r}, ${g}, ${b}, ${a})`;
                } else {
                    color = `rgb(${r}, ${g}, ${b})`;
                }
                
                colorStops.push({ color, position });
            }
            
            return { type, angle, stops: colorStops };
        } catch (error) {
            console.error('CSS gradient parsing error:', error);
            return null;
        }
    }

    // 유니크한 ID 생성 함수
    generateUniqueId(prefix: string = 'id'): string {
        const timestamp = Date.now();
        const random = Math.random().toString(36).substr(2, 9);
        const componentHash = this.model ? `${this.model.component_type}-${this.model.posx}-${this.model.posy}` : 'unknown';
        return `${prefix}-${componentHash}-${timestamp}-${random}`;
    }


}

export default EditBasic_Element
customElements.define('editbasic-element', EditBasic_Element);